// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { themr } from "react-css-themr";
import { Switch, Redirect } from "react-router-dom";
import { withRouter } from "react-router";
import classnames from "classnames";
import { PrivateRoute, sideMenu, H, Button } from "@lifepay/rc-ui-toolkit";

// ABSOLUTE PATH IMPORTS
// importing object with action creator functions
import actions from "model/actions";
import selectors from "model/selectors";

import ActionSelector from "../pages/ActionSelector";
import Page from "../pages/Page";
import Search from "../pages/Search";
import Emission from "../pages/Emission";
import Acquiring from "../pages/Acquiring";
import Client from "../side-menu/Client";
import ClientsList from "../side-menu/ClientsList";
import ServiceDesk from "../ServiceDesk";
import ClientInfo from "../ClientInfo";

import phonecallSVG from "@lifepay/assets/sprites/feather/communication/phone-call.svg";

// RELATIVE PATH IMPORTS
import styles from "./Workflow.m.scss";

// connecting component to the redux store
@withRouter
@connect(
  // mapStateToProps function - passes data from store's state.
  (state) => {
    return {
      loggedIn: selectors.user.loggedIn$$(state),
      currentClient: selectors.clients.currentClient$$(state),
      savedClients: selectors.clients.savedClients$$(state),
    };
  },
  // mapDispatchToProps object - pass individual action creators here
  {
    clearOngoingCall: actions.clients.clearOngoingCall,
  }
)
@themr("client-workflow", styles)
export default class ClientWorkflow extends Component {
  // declaring props passed to the component
  static propTypes = {
    theme: PropTypes.object,
    match: PropTypes.object,
    loggedIn: PropTypes.bool,
    currentClient: PropTypes.object,
    savedClients: PropTypes.array,
    wrongClient: PropTypes.bool,
    incomingPhoneNumber: PropTypes.string,
    clearOngoingCall: PropTypes.func,
  };

  render() {
    const {
      theme,
      loggedIn,
      match,
      currentClient,
      savedClients,
      wrongClient,
      incomingPhoneNumber,
      clearOngoingCall,
    } = this.props;

    return (
      <div className={classnames(theme.wrapper)}>
        <sideMenu.SideMenuLayout>
          <sideMenu.SideMenu>
            {wrongClient && (
              <sideMenu.Info
                header={"Текущий звонок"}
                showcase={{
                  icon: phonecallSVG,
                  text: incomingPhoneNumber,
                }}
              >
                <div className={classnames(theme["wrong-number"])}>
                  <div className={classnames(theme.status)}>
                    <H t="h6">{"Клиент не определен"}</H>
                  </div>
                  <Button
                    type={"alt"}
                    size={"small"}
                    onClick={clearOngoingCall}
                  >
                    {"Завершить звонок ✓"}
                  </Button>
                </div>
              </sideMenu.Info>
            )}
            <Switch>
              <PrivateRoute
                auth={loggedIn}
                exact
                path={`${match.path}/search`}
                render={() => (
                  <ClientsList
                    savedClients={savedClients}
                    basePath={match.path}
                  />
                )}
              />
              <PrivateRoute
                auth={loggedIn}
                path={`*`}
                render={() => (
                  <Client currentClient={currentClient} basePath={match.path} />
                )}
              />
            </Switch>
          </sideMenu.SideMenu>
          <div className={classnames(theme.body)}>
            <Switch>
              <PrivateRoute
                auth={loggedIn}
                exact
                path={`${match.path}/search`}
                render={() => <Search basePath={match.path} />}
              />
              {!currentClient && <Redirect to={`${match.path}/search`} />}
              <PrivateRoute
                auth={loggedIn}
                path={`${match.path}/:clientId/menu`}
                render={() => <ActionSelector basePath={match.path} />}
              />
              <PrivateRoute
                auth={loggedIn}
                path={`${match.path}/:clientId/acquiring`}
                render={() => <Acquiring basePath={match.path} />}
              />
              <PrivateRoute
                auth={loggedIn}
                path={`${match.path}/:clientId/emission`}
                render={() => <Emission basePath={match.path} />}
              />
              <PrivateRoute
                auth={loggedIn}
                path={`${match.path}/:clientId/support-request`}
                render={() => (
                  <Page
                    basePath={match.path}
                    pageHeader={"Заявка в ServiceDesk"}
                  >
                    <ServiceDesk basePath={match.path} />
                  </Page>
                )}
              />
              <PrivateRoute
                auth={loggedIn}
                path={`${match.path}/:clientId/info`}
                render={() => (
                  <Page
                    basePath={match.path}
                    pageHeader={"Информация о клиенте"}
                  >
                    <ClientInfo basePath={match.path} />
                  </Page>
                )}
              />
              <PrivateRoute
                auth={loggedIn}
                path="*"
                render={() => <Redirect to={`${match.path}/search`} />}
              />
            </Switch>
          </div>
        </sideMenu.SideMenuLayout>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-client/Workflow/Workflow.js